import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-sort-up",
  "use": "tamr-icon-sort-up-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-sort-up\"><path d=\"M22.8,15.4l-6-9a1,1,0,0,0-1.7,0l-6,9A1,1,0,0,0,10,17h3v8h6V17h3A1,1,0,0,0,22.8,15.4Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol